<template>
    <div class="audio_box" :class="{ gary: bg }">
        <!--audio1-->
        <div class="audio_detail">
            <audio
                :src="mp3url"
                controls
                id="audio"
                @canplay="getDuration"
                @timeupdate="timeupdate"
                @ended="ended"
                @loadedmetadata="formatePlayerDuration"
                ref="audio"
            ></audio>
            <b
                :class="{ pause: !pause }"
                class="iconfont"
                @click.stop="play()"
                >{{ pause ? "&#xe73d;" : "&#xe779;" }}</b
            >
            <div class="audio_p">
                <div class="progress" @mousedown.stop="stop" @click.stop="sss">
                    <el-slider
                        @click.stop="sss"
                        @change="elchange"
                        @input="elmove"
                        :show-tooltip="false"
                        v-model="value1"
                        :disabled="duration == 0"
                    ></el-slider>
                </div>
            </div>
            <div class="time clearfix">
                <span>{{ current_time | time }}</span
                ><span>/{{ duration | time }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "mp3play",
    data() {
        return {
            progress_g_w: 0,
            circle_w: 0,
            pause: true,
            current_time: 0,
            audio_w: 224,
            audio_w_g: "",
            nowAudioTime: 0,
            duration: 0,
            value1: 0
        };
    },
    props: {
        bg: "",
        mp3url: ""
    },
    wacth: {
        mp3url() {
            this.$refs.audio.load();
            this.$refs.audio.oncanplay = () => {
                this.getDuration();
            };
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.audio.load();
            this.$refs.audio.oncanplay = () => {
                this.getDuration();
            };
        });
    },
    methods: {
        ended(e) {
            this.current_time = 0;
            this.value1 = 0;
            this.pause = true;
        },

        sss() {},
        formatePlayerDuration(e) {
            const audio = this.$refs.audio;
            const audioDuration = this.$refs.audio.duration;
            if (audioDuration === Infinity) {
                audio.currentTime = 1e101;
                audio.ontimeupdate = function() {
                    this.ontimeupdate = () => {
                        return;
                    };
                    // 不重新设置currtTime,会直接触发audio的ended事件，因为之前将currentTime设置成了一个比音频时长还大的值。
                    // 注: 这里有一个问题，直接设置为0 是不起作用的。需要重新设置一下audio.currentTime = 1e101;然后再设置为0
                    audio.currentTime = 1e101;
                    audio.currentTime = 0;
                };
            }
        },
        getDuration() {
            this.duration = this.$refs.audio.duration | 0;
        },
        timeupdate(e) {
            this.current_time = e.target.currentTime;
            this.value1 = (this.current_time / this.duration) * 100;
        },

        play() {
            //点击播放
            console.log("play", this.duration,this.mp3url);
            if (!this.duration || !this.mp3url) {
                this.$message.error("无法播放！");
                return false;
            }
            if (this.$refs.audio.paused) {
                this.$refs.audio.play();
                this.pause = false;
            } else {
                this.$refs.audio.pause();
                this.pause = true;
            }
        },
        elchange() {
            console.log("结束", this.value1);
            if (!this.pause) {
                this.$refs.audio.play();
            }
            this.$refs.audio.currentTime = (this.value1 / 100) * this.duration;
            this.current_time = (this.value1 / 100) * this.duration;
        },
        elmove() {},
        stop() {
            this.$refs.audio.pause();
            console.log("stop");
        }
    }
};
</script>

<style lang="less">
#audio {
    width: 0px;
    height: 0px;
}

.audio_box {
    width: 328px;
    height: 22px;
    padding: 14px;
    background: #fff;
    border-radius: 2px;
    position: relative;

    &.gary {
        background: #f9fafc;
    }

    .audio_detail {
        b {
            display: block;
            position: absolute;
            width: 23px;
            height: 23px;
            color: #007bff;
            left: 14px;
            top: 14px;
            font-size: 28px;
            line-height: 24px;
            cursor: pointer;
        }
    }

    .audio_p {
        position: absolute;
        left: 54px;
        top: 50%;
        transform: translateY(-50%);
        width: 210px;

        .progress {
            width: 100%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            height: 4px;

            .circle {
                width: 10px;
                height: 10px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.22);
                position: absolute;
                border-radius: 50%;
                left: -5px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 1;

                &:after {
                    width: 40px;
                    height: 40px;
                    display: block;
                    content: "";
                    position: absolute;
                    transform: translateY(-50%);
                    top: 50%;
                    left: -10px;
                }
            }
        }

        .progress_g {
            position: absolute;
            left: 0;
            top: 0;
            width: 30%;
            height: 4px;
            border-radius: 4px;
            background: #007bff;
        }
    }

    .time {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);

        span {
            float: left;
            font-size: 12px;
            color: #2a2a2a;

            &:nth-of-type(2) {
                float: right;
            }
        }
    }
}
</style>
<style>
.audio_box .el-slider__runway,
.audio_box .el-slider__bar {
    height: 4px;
    margin: 0;
}
.audio_box .el-slider__button-wrapper {
    top: -17px;
}
.audio_box .el-slider__button {
    width: 10px;
    height: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.22);
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/mp3Play.vue